import React from "react";

const ContactMap = () => {
  return (
    <div className="map-div">
      <div className="container">
        <div className="col-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13715.482640096103!2d76.7577135!3d30.7504708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fed4300000001%3A0xb6fdf9387593a1e8!2sTerafac%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1714364736751!5m2!1sen!2sin"
            frameBorder="0"
            className="contact-map"
            allowFullScreen
            title="Terafac Technologies Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactMap;
